export default "__VITE_ASSET__D$dF2aqx__"